import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    methods: {
        changeInvoiceNumber(rawMaterialDeliveryId, invoiceNumber) {
            const url = `${serverUrl}Delivery/UpdateInvoiceNumber`;
            const dataToSend = {
                rawMaterialDeliveryId,
                invoiceNumber
            }

            return axios
                .post(url, dataToSend);
        }
    },
};
